import { Injectable, inject, effect } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { DATE_FORMATS_DE, DATE_FORMATS_EN, DATE_FORMATS_FR } from '../model/date-formats';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class DateFormatService {
  private readonly appService = inject(AppService);
  private dynamicFormat: MatDateFormats;
  private currentPipeFormat: string = 'dd/MM/yyyy';

  constructor() {
    // Create a dynamic format object that will be updated in place
    this.dynamicFormat = { ...DATE_FORMATS_FR };

    // Listen for language changes using languageCode signal
    effect(() => {
      const lang = this.appService.languageCode();
      this.updateFormats(lang);
    });

    // Set initial formats
    const lang = this.appService.languageCode();
    this.updateFormats(lang);
  }

  private updateFormats(lang: string): void {
    let formats: MatDateFormats;
    let pipeFormat: string;

    switch (lang) {
      case 'en-GB':
        formats = DATE_FORMATS_EN;
        pipeFormat = 'dd-MM-yyyy';
        break;
      case 'de-DE':
        formats = DATE_FORMATS_DE;
        pipeFormat = 'dd.MM.yyyy';
        break;
      default:
        formats = DATE_FORMATS_FR;
        pipeFormat = 'dd/MM/yyyy';
    }

    // Update the dynamic format object in place (mutate existing object)
    Object.assign(this.dynamicFormat, formats);
    this.currentPipeFormat = pipeFormat;
  }

  getDynamicFormats(): MatDateFormats {
    return this.dynamicFormat;
  }

  getAngularPipeFormat(): string {
    return this.currentPipeFormat;
  }
}
